import React, { useState } from 'react';
import './SetIcon.css';

interface SetIconProps {
  setIconUrl?: string | null;
  setName?: string;
  size?: 'sm' | 'md' | 'lg';
  inverted?: boolean;
  className?: string;
}

const sizes = { sm: 14, md: 16, lg: 20 };

export const SetIcon: React.FC<SetIconProps> = ({
  setIconUrl,
  setName,
  size = 'md',
  inverted = true,
  className = '',
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError || !setIconUrl) {
    return null;
  }

  return (
    <img
      src={setIconUrl}
      alt={setName ? `${setName} set icon` : 'Set icon'}
      width={sizes[size]}
      height={sizes[size]}
      className={`set-icon set-icon--${size} ${inverted ? 'set-icon--inverted' : ''} ${className}`}
      onError={() => setHasError(true)}
    />
  );
};
